export const AuthRecursosDigitalsMenors14 = ({ auth, handleChange, error }) => {

  return (
                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                  Autorització relativa als alumnes de menys de 14 anys: ús de serveis i recursos digitals a Internet per treballar a l’aula
                                </h4>
                                <p>


                                  <input type="checkbox" id="authRecursosDigitals" name="authRecursosDigitals" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
                                  <label htmlFor="authRecursosDigitals"> 
                                    AUTORITZO, que que el meu fill/a utilitzi, per al treball acadèmic, els serveis telemàtics i/o aplicacions de dispositius mòbils que requereixen usuari i contrasenya, els quals s’especifiquen a continuació: Creació i gestió de l'usuari i contrasenya corporativa (G-Suite), Plataformes digitals
(Moodle, Classroom...)
                                    </label>
                                    <small>La responsabilitat de l’ús que se’n faci en l’àmbit escolar correspon al centre educatiu. El centre no es fa responsable, però, de l’ús indegut del recurs i dels continguts per part dels usuaris: l’usuari serà l’únic responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui causar per un ús inadequat dels serveis o dels continguts.</small>
                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
                                </p>


                              </div>
                            </div>

  )
}

export const AuthRecursosDigitalsMenors18 = ({ auth, handleChange, error }) => {

  return (
                                      <div className="row">
                                        <div className="col col-12 ">
                                          <h4>
                                            Comunicació relativa als alumnes de més de 14 anys però menors d’edat: ús de serveis i recursos digitals a Internet per treballar a l’aula
                                          </h4>
                                          <p>


                                            <input type="checkbox" id="authRecursosDigitals" name="authRecursosDigitals" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
                                            <label htmlFor="authRecursosDigitals">
                                              Estic assabentat/ada que utilitzaré, per al treball acadèmic, els serveis telemàtics i/o aplicacions de dispositius mòbils que
                                              requereixen usuari i contrasenya que s’especifiquen a continuació: reació i gestió de l'usuari i contrasenya corporativa (G-Suite), Plataformes digitals (Moodle, Classroom...)
                                            </label>
                                            <small>La responsabilitat de l’ús que se’n faci en l’àmbit escolar correspon al centre educatiu. El centre no es fa responsable, però, de l’ús indegut del recurs i dels continguts per part dels usuaris: l’usuari serà l’únic responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui causar per un ús inadequat dels serveis o dels continguts.</small>
                                            <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
                                          </p>


                                        </div>
                                      </div>

  )
}

export const AuthRecursosDigitalsMajors18 = ({ auth, handleChange, error }) => {

  return (
                                      <div className="row">
                                        <div className="col col-12 ">
                                          <h4>Comunicació relativa als alumnes majors d'edat i als professors i personal del centre: ús de serveis i recursos digitals a Internet per treballar a l’aula.  </h4>
                                          <p>

                                            <input type="checkbox" id="authRecursosDigitals" name="authRecursosDigitals" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
                                            <label htmlFor="authRecursosDigitals"> Estic assabentat/ada que utilitzaré, per al treball acadèmic, els serveis telemàtics i/o aplicacions de dispositius mòbils que
                                              requereixen usuari i contrasenya que s’especifiquen a continuació: reació i gestió de l'usuari i contrasenya corporativa (G-Suite), Plataformes digitals (Moodle, Classroom...)
                                            </label>
                                            <small>La responsabilitat de l’ús que se’n faci en l’àmbit escolar correspon al centre educatiu. El centre no es fa responsable, però, de l’ús indegut del recurs i dels continguts per part dels usuaris: l’usuari serà l’únic responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui causar per un ús inadequat dels serveis o dels continguts.</small>
                                            <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
                                          </p>


                                        </div>
                                      </div>

  )
}
